/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosEnumGeminiVariants } from "@cosmos/hygraph-schema";

import { cva, cx } from "@panda/css";
import { Grid } from "@panda/jsx";

import { GeminiCard } from "./GeminiCard.molecule";
import type { GeminiCardProps } from "./GeminiCard.molecule";

const cardVariants = cva({
	variants: {
		variant: {
			two_up: {
				"&&": {
					gridTemplateColumns: "repeat(2, 1fr)",
					smDown: { gridTemplateColumns: "1fr" },
				},
			},
			three_up: {
				"&&": {
					gridTemplateColumns: "repeat(3, 1fr)",
					mdDown: { gridTemplateColumns: "repeat(2, 1fr)" },
					smDown: { gridTemplateColumns: "1fr" },
				},
			},
			four_up: {
				"&&": {
					gridTemplateColumns: "repeat(4, 1fr)",
					mdDown: { gridTemplateColumns: "repeat(2, 1fr)" },
					smDown: { gridTemplateColumns: "1fr" },
				},
			},
		},
	},
});

export type GeminiCardsProps = {
	cards: GeminiCardProps[];
	cardsVariant?: CosmosEnumGeminiVariants | null;
};

export function GeminiCards({ cards, cardsVariant }: GeminiCardsProps): React.JSX.Element {
	const variant =
		cardsVariant || (cards.length === 2 ? CosmosEnumGeminiVariants.TwoUp : CosmosEnumGeminiVariants.ThreeUp);
	return (
		<Grid className={cx("gemini-cards", cardVariants({ variant }))} gap="eds.dimension.16">
			{cards.map((card, i) => (
				<GeminiCard key={`gemini-card-${i}`} animate={false} {...card} />
			))}
		</Grid>
	);
}
